import * as Scrivito from 'scrivito';
import { HelperText, Message, WidgetTitle } from '../../utils/translations';
import { ValidationInfo } from '../../utils/type.utils';
import { CircleTeaserWidgetClass } from '../circle-teaser-widget';
import { CircleTeaserGroupWidgetAttributes, CircleTeaserGroupWidgetId } from './circle-teaser-group-widget-definitions';
import { spacingAttributes, spacingContent, spacingGroup } from '../../utils/scrivito/spacing-definitions';
import CircleTeaserThumbnail from '../../assets/thumbnails/circle-teaser.svg';

const minRequiredTeaser = 2;
const defaultTeaser = 3;
const maxAllowedTeaser = 4;

Scrivito.provideEditingConfig(CircleTeaserGroupWidgetId, {
  title: WidgetTitle.CIRCLE_TEASER_GROUP,
  thumbnail: CircleTeaserThumbnail,
  properties: Object.values(CircleTeaserGroupWidgetAttributes),
  propertiesGroups: [spacingGroup],
  attributes: {
    [CircleTeaserGroupWidgetAttributes.CIRCLE_TEASER]: {
      title: HelperText.CIRCLE_TEASER_GROUP_TEASER,
    },
    ...spacingAttributes,
  },
  validations: [
    [
      CircleTeaserGroupWidgetAttributes.CIRCLE_TEASER,
      (widgets: Array<Scrivito.Widget>): ValidationInfo => {
        if (widgets && widgets.length < minRequiredTeaser) {
          return {
            message: Message.CIRCLE_TEASER_GROUP_MIN_ITEMS,
            severity: 'error',
          };
        }
        if (widgets && widgets.length > maxAllowedTeaser) {
          return {
            message: Message.CIRCLE_TEASER_GROUP_MAX_ITEMS,
            severity: 'error',
          };
        }

        return undefined;
      },
    ],
  ],
  initialContent: {
    [CircleTeaserGroupWidgetAttributes.CIRCLE_TEASER]: Array.from(
      { length: defaultTeaser },
      () => new CircleTeaserWidgetClass()
    ),
    ...spacingContent,
  },
});
